// All operational policies are DATA (settings/policies), never hard-coded in UI.
export interface AcademyPolicies {
  timezone: string;
  currency: string;
  booking: {
    opensHoursBefore: number;
    closesMinutesBefore: number;
    cancelMinutesBefore: number;
    maxActiveBookings: number;
    waitlistMode: 'autoAssign' | 'offer';
    waitlistOfferMinutes: number;
    waitlistCutoffMinutes: number;
    requireBookingToCheckIn: boolean;
    checkInOpensMinutesBefore: number;
    checkInClosesMinutesAfter: number;
  };
  membership: {
    pastDueCanBook: boolean;
    pastDueBlockAfterDays: number;
    graceDays: number;
    countWeekLimitBy: 'bookings' | 'attendance';
  };
  failedPayments: {
    retryScheduleDays: number[];
    notifyMemberOnFailure: boolean;
    notifyAdminOnFailure: boolean;
    escalateAfterAttempts: number;
    restrictBookingAfterAttempts: number | null;
  };
  engagement: { inactiveDays: number[]; declinePct: number; noShowThreshold: number; };
  signup: { allowSelfSignup: boolean; };
}

export const DEFAULT_POLICIES: AcademyPolicies = {
  timezone: 'Europe/Madrid', currency: 'EUR',
  booking: { opensHoursBefore: 168, closesMinutesBefore: 0, cancelMinutesBefore: 120, maxActiveBookings: 6,
    waitlistMode: 'autoAssign', waitlistOfferMinutes: 60, waitlistCutoffMinutes: 30,
    requireBookingToCheckIn: false, checkInOpensMinutesBefore: 60, checkInClosesMinutesAfter: 30 },
  membership: { pastDueCanBook: true, pastDueBlockAfterDays: 14, graceDays: 3, countWeekLimitBy: 'bookings' },
  failedPayments: { retryScheduleDays: [3, 5, 7], notifyMemberOnFailure: true, notifyAdminOnFailure: true,
    escalateAfterAttempts: 3, restrictBookingAfterAttempts: 3 },
  engagement: { inactiveDays: [7, 14, 30, 60], declinePct: 50, noShowThreshold: 3 },
  signup: { allowSelfSignup: true },
};
